module.exports = __webpack_public_path__ + "svg/classic-jacket.a5e23e19dd2b0a9c19d166b567c65f4a.svg";